import Http from "../../http/client";

export default async () => {
    const response = await Http.get(`trip/driver/membershipprice`);
    return response.data;
}
